
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class TargetDistributionGrid extends Serenity.EntityGrid<TargetDistributionRow, any> {
        protected getColumnsKey() { return 'Master.TargetDistribution'; }
        protected getDialogType() { return TargetDistributionDialog; }
        protected getIdProperty() { return TargetDistributionRow.idProperty; }
        protected getInsertPermission() { return TargetDistributionRow.insertPermission; }
        protected getLocalTextPrefix() { return TargetDistributionRow.localTextPrefix; }
        protected getService() { return TargetDistributionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}